/**
 * readmore.js — cắt bớt đoạn mô tả dài và thêm nút View more / View less.
 *
 * Markup:  [data-readmore] > [data-readmore-body] + button[data-readmore-toggle]
 * Phần cắt do CSS lo (-webkit-line-clamp), JS chỉ quyết định có hiện nút hay không
 * nên nội dung ngắn sẽ không thấy nút thừa. Không có JS thì mô tả vẫn đọc được,
 * chỉ là bị cắt — vì vậy nút để sẵn thuộc tính hidden trong HTML.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var blocks = [].slice.call(document.querySelectorAll('[data-readmore]'));
    if (!blocks.length) return;

    blocks.forEach(function (block) {
        var body = block.querySelector('[data-readmore-body]');
        var toggle = block.querySelector('[data-readmore-toggle]');
        var label = block.querySelector('[data-readmore-label]');
        if (!body || !toggle) return;

        var moreText = label ? label.textContent : 'View more';
        var lessText = 'View less';

        function overflowing() {
            return body.scrollHeight - body.clientHeight > 4;
        }

        function syncToggle() {
            // Chỉ ẩn/hiện nút khi đang ở trạng thái thu gọn
            if (block.classList.contains('is-expanded')) return;
            toggle.hidden = !overflowing();
        }

        toggle.addEventListener('click', function () {
            var expanded = !block.classList.contains('is-expanded');
            block.classList.toggle('is-expanded', expanded);
            toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            if (label) label.textContent = expanded ? lessText : moreText;
        });

        var timer;
        window.addEventListener('resize', function () {
            window.clearTimeout(timer);
            timer = window.setTimeout(syncToggle, 150);
        });

        syncToggle();
    });
})();
